"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyWallGeometry = void 0;
class LegacyWallGeometry {
    constructor(_heightmap, wallHeight = 0, roomScale = 64, entryX = -1, entryY = -1) {
        var _a, _b;
        this._heightmap = _heightmap;
        this._width = (_b = (_a = _heightmap[0]) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        this._height = _heightmap.length;
        this._roomScale = roomScale;
        this._wallHeight = wallHeight;
        this._entryX = entryX;
        this._entryY = entryY;
        this._highestTile = this.calcHighestTile();
    }
    calcHighestTile() {
        let highest = 0;
        for (let y = 0; y < this._height; y++) {
            const row = this._heightmap[y];
            if (!row)
                continue;
            for (let x = 0; x < row.length; x++) {
                const cell = row[x];
                if (cell && (cell.type === "tile" || cell.type === "stairs" || cell.type === "door")) {
                    if (cell.z > highest)
                        highest = cell.z;
                }
            }
        }
        return highest;
    }
    calcWallHeight(wallX, wallY) {
        let result = LegacyWallGeometry.BASE_OFFSET;
        const isEntry = wallX === this._entryX && wallY === this._entryY;
        if (this._wallHeight !== -1 && this._wallHeight > 0) {
            result = isEntry
                ? result + this._wallHeight
                : result + (this._wallHeight * 2);
        }
        else if (!isEntry) {
            result += this._highestTile;
        }
        let tileh = -1;
        if (wallX >= 0 && wallY >= 0 && wallX < this._width && wallY < this._height) {
            const row = this._heightmap[wallY];
            if (row) {
                const cell = row[wallX];
                if (cell && (cell.type === "tile" || cell.type === "stairs" || cell.type === "door")) {
                    tileh = cell.z;
                }
            }
        }
        else if (wallX < 0 || wallY < 0 || wallX >= this._width || wallY >= this._height) {
            tileh = 0;
        }
        if (isEntry) {
            tileh = -1;
        }
        return tileh >= 0 ? tileh : result;
    }
    getLocation(roomX, roomY, offsetX, offsetY, wall) {
        const unitsize = 64 / this._roomScale;
        const heightoffset = this.calcWallHeight(roomX, roomY);
        let rX = roomX;
        let rY = roomY;
        let rZ = heightoffset;
        if (wall === LegacyWallGeometry.RIGHT_WALL) {
            rX = rX + (offsetX * unitsize) / LegacyWallGeometry.HALF_W - 0.5;
            rY = rY + 0.5;
            rZ = rZ - (offsetY * unitsize - (offsetX * unitsize) / 2) / LegacyWallGeometry.HALF_W;
        }
        else {
            rY = rY + (LegacyWallGeometry.HALF_W - offsetX * unitsize) / LegacyWallGeometry.HALF_W - 0.5;
            rX = rX + 0.5;
            rZ = rZ - (offsetY * unitsize - (LegacyWallGeometry.HALF_W - offsetX * unitsize) / 2) / LegacyWallGeometry.HALF_W;
        }
        return { x: rX, y: rY, z: rZ };
    }
    getHeight(x, y) {
        return this.calcWallHeight(x, y);
    }
    findAdjacentFloorHeight(x, y) {
        const directions = [
            [1, 0], [0, 1], [1, 1], [-1, 0], [0, -1], [-1, -1], [1, -1], [-1, 1]
        ];
        for (const [dx, dy] of directions) {
            const nx = x + dx;
            const ny = y + dy;
            if (nx < 0 || nx >= this._width || ny < 0 || ny >= this._height)
                continue;
            const row = this._heightmap[ny];
            if (!row)
                continue;
            const cell = row[nx];
            if (cell && (cell.type === "tile" || cell.type === "stairs" || cell.type === "door")) {
                return cell.z;
            }
        }
        return 0;
    }
}
exports.LegacyWallGeometry = LegacyWallGeometry;
LegacyWallGeometry.LEFT_WALL = "l";
LegacyWallGeometry.RIGHT_WALL = "r";
LegacyWallGeometry.HALF_W = 32;
LegacyWallGeometry.HALF_H = 16;
LegacyWallGeometry.BASE_OFFSET = 3.59375;
